import { ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';
import { DateTime } from 'luxon';

const TOP_LEVEL_ID = 'week-header-item';
const { label, labelBold } = EquipUITheme.typography;

interface ScheduleWeekHeaderItemProps {
  date: DateTime;
  weekday: string;
}

const ScheduleWeekHeaderItem = ({
  date,
  weekday,
}: ScheduleWeekHeaderItemProps) => {
  const numericDate = date.toLocaleString({ day: 'numeric', month: 'numeric' });
  return (
    <ChakraFlex
      alignItems="center"
      color="neutral.secondary"
      id={`${TOP_LEVEL_ID}`}
      justify="center"
      marginY="auto"
      width="15%"
    >
      <ChakraText id={`${TOP_LEVEL_ID}__${weekday}`} {...labelBold}>
        {weekday}
      </ChakraText>
      &nbsp;
      <ChakraText id={`${TOP_LEVEL_ID}__${numericDate}`} {...label}>
        {numericDate}
      </ChakraText>
    </ChakraFlex>
  );
};

export default ScheduleWeekHeaderItem;
